module.exports = __webpack_public_path__ + "img/6f0bfc1.png";